export default __webpack_public_path__ + "static/media/step2_3.96f52346.png";